import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ProposalRequestForm } from '../components/ProposalRequestForm'
import { MobilePage, MobilePageHeader } from '../components/mobile'

export default function ProposalRequestCreate() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const customerId = searchParams.get('customerId')
  const leadId = searchParams.get('leadId')
  const returnTo = searchParams.get('returnTo')

  const handleClose = () => {
    if (returnTo) {
      navigate(decodeURIComponent(returnTo))
    } else {
      navigate('/proposals')
    }
  }

  const handleSuccess = () => {
    if (returnTo) {
      navigate(decodeURIComponent(returnTo))
    } else {
      navigate('/proposals')
    }
  }

  return (
    <MobilePage className="max-w-6xl mx-auto pb-28 lg:pb-8">
      <MobilePageHeader
        sticky
        title="Submit Proposal Request"
        onBack={handleClose}
        backLabel={returnTo ? 'Back' : 'Back to Proposals'}
      />
      <ProposalRequestForm
        onClose={handleClose}
        onSuccess={handleSuccess}
        initialCustomerId={customerId || undefined}
        initialLeadId={leadId || undefined}
        editingRequest={undefined}
        viewingRequest={undefined}
        isFullPage={true}
      />
    </MobilePage>
  )
}

